export { Link, isExtLink, LinkText } from './Link'
export { LinkButton } from '../Button/LinkButton'
/** @deprecated */
export type { LinkProps } from './Link'
